import moment from 'moment';

const isNullOrUndefined = (value) => { 
  // eslint-disable-next-line
  return (typeof value == 'undefined' || value === null);
}

const preparePlainValue = (value) => {
  return value instanceof Object && value.toString
      ? value.toString()
      : isNullOrUndefined(value) ? '' : value;
}

const isNestedValue = value =>
  value instanceof Array ||
  (value instanceof Object &&
    value.toString &&
    value.toString() === {}.toString());

const prepareNestedValue = (nestedKey, nestedValue, reduce = {}) => {
  if (isNestedValue(nestedValue)) {
    return Object.keys(nestedValue).reduce(
      (reduce, nestedSubKey) => ({
        ...reduce,
        ...prepareNestedValue(
          nestedValue instanceof Array
            ? `${nestedKey}[${nestedSubKey}]`
            : `${nestedKey}.${nestedSubKey}`,
          nestedValue[nestedSubKey],
          reduce
        )
      }),
      reduce
    );
  }

  if (nestedValue instanceof File) {
    return { [nestedKey]: nestedValue };
  } else if (nestedValue instanceof moment) {
    return { [nestedKey]: nestedValue.format() };
  }

  return {
    [nestedKey]: preparePlainValue(nestedValue)
  };
};

export default (jsonObject = {}) => {
  const formData = new FormData();

  Object.keys(jsonObject).forEach(objectKey => {
    const objectKeyValue = jsonObject[objectKey];

    
    if (!isNullOrUndefined(objectKeyValue)) {
      if (objectKeyValue instanceof File) {
        formData.append(objectKey, objectKeyValue, objectKeyValue.name);
      } else if (objectKeyValue instanceof moment) {
        formData.append(objectKey, objectKeyValue.format());
      } else if (isNestedValue(objectKeyValue)) {
        const preparedResult = prepareNestedValue(objectKey, objectKeyValue);
        Object.keys(preparedResult).forEach(key =>
        
          formData.append(key, preparedResult[key])
        );
      } else {
        formData.append(objectKey, preparePlainValue(objectKeyValue));
      }
    }
  });

  return formData;
};



// WEBPACK FOOTER //
// ./src/tools/form-data-encode.js